import Table from "./TableWrpper";

export default Table;
